// extracted by mini-css-extract-plugin
export default {"inputSearch":"input-search_inputSearch__-yKpO"};